module.exports = __webpack_public_path__ + "media/images/icons/country_flags/kp-1bcf41f7359a335ca2d809e7a77659e3.svg";